<template>
  <section class="member-signup" v-if="subscriptionType === 'employed'">
    <div class="row">
      <div class="col-xs-12">
        <div class="field-wrapper required">
          <DropDownWithSearchEndpoint
            ref="dropdownRef"
            id="companyName"
            endpoint="/umbraco/api/signup/SearchCompanyList/?search="
            execsearch="1"
            :noresults="d.searchNoResults"
            :label="d.companyName + '*'"
            @change="SetValue($event, 'companyName')"
          >
          </DropDownWithSearchEndpoint>

          <div
            class="input-errors no-margin"
            v-for="error of v$.values.companyName.$errors"
            :key="error.$uid"
          >
            <div
              v-if="error.$validator == 'required' && !error.$response"
              class="error-msg"
            >
              {{ d.errorcompanyname }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="field-wrapper half required">
          <label for="company-name-address">{{ d.companyAddress }}</label>
          <input type="text" id="company-name-address" v-model="values.companyAddress" :placeholder="d.placeholdertextbox" />

          <div class="input-errors" v-for="error of v$.values.companyAddress.$errors" :key="error.$uid" >
            <div v-if="error.$validator == 'forbiddenChars' && !error.$response" class="error-msg">{{ d.errorforbiddencharacters }}</div>
          </div>

        </div>
      </div>

      <div class="col-xs-12 col-sm-6">
        <div class="field-wrapper half required">
          <label for="company-name-postal-code">{{ d.companyPostalCode }}</label>
          <input type="text" id="company-name-postal-code" v-model="values.companyPostalCode" :placeholder="d.placeholdertextbox"/>

        </div>
      </div>
    </div>

    <div class="row" v-for="(workSet, index) in values.workSets" :key="index">
      <div class="col-md-6 col-xs-12">
        <div class="field-wrapper small">
          <DropDownWithSearch
            :ref="`dropdownAreaRef-${index}`"
            :id="`workAreas-${index}`"
            :label="d.companyWorkArea + '*'"
            @change="handleAreaChange($event, index, 'dropdownFunctionRef', 'workFunctions')"
            :options="dictionaryWorkAreas"
          ></DropDownWithSearch>

          <div
            class="input-errors no-margin"
            v-for="error of v$.values.workAreas.$errors"
            :key="error.$uid"
          >
            <div
              v-if="error.$validator == 'worksetValidationArea' && !error.$response"
              class="error-msg"
            >
              {{ d.errorworkarea }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xs-12">
        <div class="field-wrapper small" v-show="workSet.area != null">
          <DropDownWithSearch
            :ref="`dropdownFunctionRef-${index}`"
            :id="`workFunctions-${index}`"
            :label="d.companyWorkFunction + '*'"
            @change="handleFunctionChange($event, index)"
            :options="dictionaryWorkFunctions"
          ></DropDownWithSearch>

          <div
            class="input-errors no-margin"
            v-for="error of v$.values.workFunctions.$errors"
            :key="error.$uid"
          >
            <div
              v-if="error.$validator == 'worksetValidationFunction' && !error.$response"
              class="error-msg"
            >
              {{ d.errorworkfunction }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <button class="next-workarea-btn" @click="addWorkSet">
          {{ nextWorkAreaButtonText }}
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M13 6.88281L12.9821 19.0813" stroke="#001965" stroke-width="2" />
            <path d="M19.0903 12.9805L6.89182 12.9805" stroke="#001965" stroke-width="2" />
            <circle cx="13" cy="13" r="12" stroke="#001965" stroke-width="2" />
          </svg>
        </button>
      </div>
      <div class="col-sm-6" style="text-align: right;">
        <button class="next-workarea-btn" @click="removeWorkSet" style="float:right" v-if="values.workSets[0].area">
          {{d.cancel}}
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            
            <path d="M19.0903 12.9805L6.89182 12.9805" stroke="#001965" stroke-width="2" />
            <circle cx="13" cy="13" r="12" stroke="#001965" stroke-width="2" />
          </svg> 
        </button>
      </div>
    </div>

    



    

    <div class="row" v-if="visual.showPayByCompany" style="margin-top:55px !important">
      <div class="col-xs-12">
        <div class="field-wrapper full">
          <div>{{ d.companyPayByCompanyTitle }}</div>

          <label for="company-name">{{ d.companyPayByCompany }}</label>
          <div class="list-inline">
            <label class="radio">
              <input type="radio" name="payByCompany" required="true" v-model="values.payByCompany" @change="emitter.emit('pay-by-company-change')" :value="true" />
              <span class="checklabel">{{d.companypaybycompanyyeslabel}}</span>
              <span class="checkmark"></span>
            </label>

            <label class="radio">
              <input type="radio" name="payByCompany" required="true" v-model="values.payByCompany" @change="emitter.emit('pay-by-company-change')" :value="false" />
              <span class="checklabel">{{d.companypaybycompanynolabel}}</span>
              <span class="checkmark"></span>
            </label>
          </div>

          <div class="input-errors no-margin" v-for="error of v$.values.payByCompany.$errors" :key="error.$uid" >
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg" >
              {{ d.errorpaybycompany }}
            </div>
          </div>

          <div class="col-md-6 col-xs-12 no-padding-left">
            <HelperTip :rte="d.helperPayByCompany"></HelperTip>
          </div>
        </div>
      </div>
    </div>
  </section>


  <!--todo, use worksets in store-->
  <section class="member-signup" v-if="subscriptionType === 'unemployed'">
    <div class="row" v-for="(workSet, index) in values.workSets" :key="index">
      <div class="col-md-6 col-xs-12">
        <div class="field-wrapper full">
          <DropDownWithSearch
            :ref="`dropdownUEAreaRef-${index}`"
            :id="`unemployedWorkAreas-${index}`"
            :label="d.unemployedWorkArea+'*'"
            @change="handleAreaChange($event, index, 'dropdownUEFunctionRef', 'unemployedWorkFunction')"
            :options="dictionaryWorkAreas"
          ></DropDownWithSearch>

          <div
            class="input-errors no-margin"
            v-for="error of v$.values.unemployedWorkArea.$errors"
            :key="error.$uid"
          >
            <div
              v-if="error.$validator == 'worksetValidationArea' && !error.$response"
              class="error-msg"
            >
              {{ d.errorworkarea }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xs-12">
        <div class="field-wrapper full" v-show="workSet.area != null">
          <DropDownWithSearch
            :ref="`dropdownUEFunctionRef-${index}`"
            :id="`unemployedWorkFunctions-${index}`"
            :label="d.unemployedWorkFunction+'*'"
            @change="handleFunctionChange($event, index)"
            :options="dictionaryWorkFunctions"
          ></DropDownWithSearch>

          <div
            class="input-errors no-margin"
            v-for="error of v$.values.unemployedWorkFunction.$errors"
            :key="error.$uid"
          >
            <div
              v-if="error.$validator == 'worksetValidationFunction' && !error.$response"
              class="error-msg"
            >
              {{ d.errorworkfunction }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  
</template>

<script>
import axios from "axios";
import useVuelidate from "@vuelidate/core";
import DropDownWithSearch from "../FormComponents/DropDownWithSearch.vue";
import DropDownWithSearchEndpoint from "../FormComponents/DropDownWithSearchEndpoint.vue";
import HelperTip from "../FormComponents/HelperTip.vue";
import { cultureMixin } from '../../util/cultureMixin.js';

export default {
  components: {
    DropDownWithSearch,
    DropDownWithSearchEndpoint,
    HelperTip,
  },
  mixins: [cultureMixin],
  setup() {
    // we use vuelidate for validation
    // https://vuelidate-next.netlify.app/
    return { v$: useVuelidate({ $lazy: true }) };
  },
  data: (instance) => {
    return {
      subscriptionType: instance.store.subscriptionType,
      values: instance.store[instance.store.currentCulture].values.personalDetails,
      d: instance.store[instance.store.currentCulture].dictionary,
      culture: instance.store.currentCulture,
      visual: instance.store[instance.store.currentCulture].values.visualDetails,
      dictionaryWorkAreas: [],
      dictionaryWorkAreasLoading: false,
      dictionaryWorkAreasError: null,
      dictionaryWorkFunctions: [],
      dictionaryWorkFunctionsLoading: false,
      dictionaryWorkFunctionsError: null,
    };
  },
  computed: {
    nextWorkAreaButtonText() {
      return this.values.workSets?.length < 2
        ? this.d.companyAddSecondaryWorkArea
        : this.d.companyAddAnotherWorkArea;
    },
  },
  watch: {
    "values.educationType"(value) {
      if (value == "videregaaendeuddannelse") {
        this.isEducation = true;
        this.isTrainee = false;
      } else {
        this.isEducation = false;
        this.isTrainee = true;
      }
    },
  },
  beforeUnmount() {
    this.emitter.off('culture-change', this.loadData);
  },
  methods: {
    loadData(){
      //
      // LOADS DATA
      console.log('Load data initiated');
      this.GetWorkAreas();
    },
    /* ----- */
    /* ADD WORK AREA AND FUNCTION */
    handleAreaChange(value, index, resetField, resetValidation){
      const ref = this.$refs[`${resetField}-${index}`];
      if(ref && ref.length) ref[0].reset();

      console.log('v$', this.v$.values[`${resetValidation}`]);
      if(this.v$.values[`${resetValidation}`])
        this.v$.values[`${resetValidation}`].$reset();

      if(value)
        this.dictionaryWorkFunctions = value.functions.map(x => ({id: x.subcategory, name: x.subcategoryText}));

      this.values.workSets[index].area = value;
    },
    handleFunctionChange(value, index) {
      this.values.workSets[index].function = value;
    },
    addWorkSet() {
      this.values.workSets.push({ area: null, function: null });
    },
    removeWorkSet() {
      if (this.values.workSets.length == 1) {
        this.values.workSets[0].area = null;
        this.values.workSets[0].function = null;

        const ref = this.$refs[`dropdownAreaRef-0`];
      if(ref && ref.length) ref[0].reset();
      }
      else this.values.workSets.pop();
    },
    /* ADD WORK AREA AND FUNCTION */
    /* ----- */

    SetValue(event, field) {
      switch (field) {
        case "companyName":
          this.values.companyName = event.selectedValue.name;
          this.visual.showPayByCompany = event.selectedValue.payrolldeduction;
          break;

        case "area":
          this.values.unemployedWorkArea = event.name;
          break;

        case "function":
          this.values.unemployedWorkFunction = event.name;
          break;
      }
    },
    async GetWorkAreas() {
      this.dictionaryWorkAreasLoading = true;
      this.dictionaryWorkAreasError = null;

      try {
        const dataWorkAreas = await axios.get(
          `/umbraco/api/signup/GetWorkAreas?culture=${this.GetCulture()}`
        );
        
        this.dictionaryWorkAreas = dataWorkAreas.data.map(x => ({id: x.category, name: x.categoryText, functions: x.subcategories}));
        
      } catch (error) {
        this.dictionaryWorkAreasError =
          "Der opstod en fejl under hentning af data:" + error.message;
        console.error(this.dictionaryWorkAreasError);
      } finally {
        this.dictionaryWorkAreasLoading = false;
      }
    },
    dateFormat(date) {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    },
  },
  mounted() {
    this.loadData();

    this.visual.showPayByCompany = false;

    this.emitter.on("culture-change", () => {
      this.values = this.store[this.store.currentCulture].values.personalDetails;
      this.d = this.store[this.store.currentCulture].dictionary;
      this.culture = this.store.currentCulture;

      // LOADS DATA ON LANGUAGE CHANGE
      this.loadData();

      this.v$.$reset();
    });
  },
  validations() {
    return this.validations.workPlaceDetails;
  },
};
</script>

<style scoped lang="postcss">
.input-errors {
  color: red;
  margin-top: -15px;
  + .input-errors {
    margin-top: 0;
  }
}

.small {
  margin-bottom: var(--grid-gutter-half);
}

.no-margin {
  margin-top: 0;
}

.next-workarea-btn {
  color: var(--dark-blue, #001965);
  font-family: Italian Plate No2 Expanded;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.32px;

  display: flex;
  gap: 10px;
  align-items: center;

  svg {
    transition: all ease 0.2s;
  }
  &:hover {
    svg {
      transform: translateY(-3px);
    }
  }
}

.no-padding-left {
  padding-left: 0;
}

.no-bottom-margin {
  /* margin-bottom: 0 !important; */
}
</style>